var React = require('react');
var ReactNative = require('react-native');


var Animated = require('./wrappers/Animated')

var Icon = require('./wrappers/ReUpIcon');

var ReUpScrollView = require('./ReUpScrollView.js');
var ShadowView = require('./ShadowView.js');

var Globals = require('./Globals');
var NetworkManager = require('./NetworkManager.js');
var ModelConstants = require('./constants/ModelConstants.js');

var MK = require('./wrappers/react-native-material-kit-wrapper');
var {
  MKColor,
  MKCardStyles,
  MKTextField,
  MKButton
} = MK;

var MKSegmentControl = require('./MKSegmentControl.js');
var ReUpButton = require('./ReUpButton.js');
var ReUpIconButton = require('./ReUpIconButton.js');
var ReUpField = require('./ReUpField.js');
var ReUpText = require('./ReUpText');

var {
  AppRegistry,
  Platform,
  Text,
  View,
  Image,
  ScrollView,
  DeviceEventEmitter,
  StyleSheet,
} = ReactNative;

var Camera = require('./wrappers/react-native-camera-wrapper');

function removeSpaces(str)
{
  return str.replace(/\s+/g, '');
}

var AbsorbGiftCard = require("create-react-class")(
{
  getDefaultProps : function()
  {
    return {
      appManager : null,
      initialLayout : {},
    }
  },

  getInitialState : function()
  {
    return {
      layout : this.props.initialLayout,
      message : "",
      numMessageLines : 1,
      sendButton:"Send",//TODO:localize
      emailError:false,
      giftCardNumber:"",
      shouldShowButton:false,
      buttonOpacity:new Animated.Value(0),
      qrCodeOpacity:new Animated.Value(0),
      shouldShowCamera:false,
    }
  },

  componentDidMount : function()
  {

  },

  componentWillUnmount : function()
  {
  },

  _camera : null,
  _canCapture : false,
  cameraDidLoad : function(camera)
  {
    if( !camera ) return;
    this._canCapture = true;
    this._camera = camera;
  },

  onBarCodeRead : function(evt)
  {
    //console.log(evt)
    // {"data":"eyJVIjoiMTUwIiwiVCI6IkdDIiwiSCI6IjIyMGY2ZWNjZDIifQ==","type":"org.iso.QRCode","bounds":{"size":{"width":"0.377938","height":"0.672479"},"origin":{"x":"0.348706","y":"0.132129"}}}
    this.didScanData(evt.data);
  },

  _PIN : "",
  showPinScreen : function()
  {
    this._PIN = "";
    var thisThing = this;
    var appManager = this.props.appManager;
    var locManager = appManager.getLocalizationManager();
    var okButton = locManager.localizedStringForKey("ENTER_PIN_CONFIRMATION");
    var title = locManager.localizedStringForKey("ENTER_PIN_STATEMENT");
    var body = locManager.localizedStringForKey("ENTER_PIN_INSTRUCTIONS");;
    var customAlert = <ScrollView bounces={true} style={{margin:0,padding:10,marginLeft:10,marginRight:10}}
      keyboardShouldPersistTaps={true}
      keyboardDismissMode={"interactive"}>
      <ReUpText appManager={typeof appManager === 'undefined' ? null : appManager} isTitle={true} style={{marginTop:10, textAlign:'center'}}>
        {title}
      </ReUpText>
      <ReUpText appManager={typeof appManager === 'undefined' ? null : appManager} style={{marginTop:10, textAlign:'left'}}>
        {body}
      </ReUpText>
      <ReUpField
        appManager={appManager}
        onChangeText={(text) => {thisThing._PIN = text}}
        placeholder={"PIN"}
        maxLength={5}
        keyboardType={"phone-pad"}
        style={[styles.textField]}/>
      <ReUpButton style={[styles.button,{marginTop:20}]}
        appManager={appManager}
        text={okButton}
        onPress={() => {
          // removing check in case there is no pin
          // if( thisThing._PIN.length >= 5 )
          {
            thisThing.submitPressed()
          }
        }}
        />
    </ScrollView>;
    this.props.appActions.setCustomAlertShown(true, customAlert, function(){});
  },

  submitPressed : function()
  {
    var thisThing = this;
    var isUsingUserID = this._userID != null && this._userID.length > 0;
    var appActions = this.props.appActions;
    var appManager = this.props.appManager;
    var locManager = this.props.appManager.getLocalizationManager();
    appActions.hideAlert();
    if( isUsingUserID )
    {
      appActions.setSpinnerShown(true, locManager.localizedStringForKey("FETCHING_HUD"));
      NetworkManager.getGCInfoByUserID( this.props.appManager, this._userID, this._PIN, function(data)
      {
        appActions.setSpinnerShown(false);
        var points = locManager.localizedPoints(data.Points);
        var credit = locManager.localizedDollars(data.Credit);
        var msg = locManager.localizedStringForKeyAndParams("ABSORB_GIFT_CARD_ALERT_BODY", [credit, points]);
        appActions.showLocalizedAlert(locManager.localizedStringForKey("ABSORB_GIFT_CARD_ALERT_TITLE"), msg, ["NO_ALERT_BUTTON","YES_ALERT_BUTTON"], [function()
        {
          appActions.hideAlert();
        },function()
        {
          appActions.hideAlert();
          thisThing.submitAbsorb();
        }], function(){})
      },function(data)
      {
        appActions.setSpinnerShown(false);
        appActions.showLocalizedAlert("MERGE_GC_FAIL_ALERT_TITLE", "MERGE_GC_FAIL_ALERT_BODY", ["OK_ALERT_BUTTON"], [function()
        {
          appActions.hideAlert();
        }], function(){})
      },function(data)
      {
        appActions.setSpinnerShown(false);
        appActions.showNetworkErrorAlert(thisThing.showSetCard, function(){})
      })
    }
    else
    {
      appActions.setSpinnerShown(true, "Fetching...");
      NetworkManager.getGCInfoByGCNum( this.props.appManager, this._number, this._PIN, function(data)
      {
        appActions.setSpinnerShown(false);
        var points = locManager.localizedPoints(data.Points);
        var credit = locManager.localizedDollars(data.Credit);
        var msg = locManager.localizedStringForKeyAndParams("ABSORB_GIFT_CARD_ALERT_BODY", [credit, points]);
        appActions.showLocalizedAlert(locManager.localizedStringForKey("ABSORB_GIFT_CARD_ALERT_TITLE"), msg, ["NO_ALERT_BUTTON","YES_ALERT_BUTTON"], [function()
        {
          appActions.hideAlert();
        },function()
        {
          appActions.hideAlert();
          thisThing.submitAbsorb();
        }], function(){})
      },function(data)
      {
        appActions.setSpinnerShown(false);
        appActions.showLocalizedAlert("MERGE_GC_FAIL_ALERT_TITLE", "MERGE_GC_FAIL_ALERT_BODY", ["OK_ALERT_BUTTON"], [function()
        {
          appActions.hideAlert();
        }], function(){})
      },function(data)
      {
        appActions.setSpinnerShown(false);
        appActions.showNetworkErrorAlert(thisThing.showSetCard, function(){})
      })
    }
  },

  submitAbsorb : function()
  {
    var isUsingUserID = this._userID != null && this._userID.length > 0;
    var appActions = this.props.appActions;
    var appManager = this.props.appManager;
    var locManager = appManager.getLocalizationManager();
    var thisThing = this;
    appActions.hideAlert();
    if( isUsingUserID )
    {
      appActions.setSpinnerShown(true, locManager.localizedStringForKey("MERGING_HUD"));
      NetworkManager.absorbGiftCardByUserID( this.props.appManager, this._userID, this._PIN, function(data)
      {
        appActions.setSpinnerShown(false);
        appActions.showLocalizedAlert("MERGE_GC_SUCCESS_ALERT_TITLE", "MERGE_GC_SUCCESS_ALERT_BODY", ["OK_ALERT_BUTTON"], [function()
        {
          appActions.hideAlert();
          appActions.requestPop();
        }], function(){})
      },function(data)
      {
        appActions.setSpinnerShown(false);
        appActions.showLocalizedAlert("MERGE_GC_FAIL_ALERT_TITLE", "MERGE_GC_FAIL_ALERT_BODY", ["OK_ALERT_BUTTON"], [function()
        {
          appActions.hideAlert();
        }], function(){})
      },function(data)
      {
        appActions.setSpinnerShown(false);
        appActions.showNetworkErrorAlert(thisThing.showSetCard, function(){})
      })
    }
    else
    {
      appActions.setSpinnerShown(true, locManager.localizedStringForKey("MERGING_HUD"));
      NetworkManager.absorbGiftCardByNumber( this.props.appManager, this._number, this._PIN, function(data)
      {
        appActions.setSpinnerShown(false);
        appActions.showLocalizedAlert("MERGE_GC_SUCCESS_ALERT_TITLE", "MERGE_GC_SUCCESS_ALERT_BODY", ["OK_ALERT_BUTTON"], [function()
        {
          appActions.hideAlert();
          appActions.requestPop();
        }], function(){})
      },function(data)
      {
        appActions.setSpinnerShown(false);
        appActions.showLocalizedAlert("MERGE_GC_FAIL_ALERT_TITLE", "MERGE_GC_FAIL_ALERT_BODY", ["OK_ALERT_BUTTON"], [function()
        {
          appActions.hideAlert();
        }], function(){})
      },function(data)
      {
        appActions.setSpinnerShown(false);
        appActions.showNetworkErrorAlert(thisThing.showSetCard, function(){})
      })
    }
  },

  send : function(amount, email, message)
  {
    var thisThing = this;
    var appManager = this.props.appManager;
    var appActions = this.props.appActions;
    var locManager = appManager.getLocalizationManager();
    var processingHUD = locManager.localizedStringForKey("PAYING_HUD");
    appActions.setSpinnerShown(true, processingHUD);
    NetworkManager.sendCredit( appManager, amount, email, message, function(data)
    {
      appActions.setSpinnerShown(false);
      var user = appManager.currentUser();
      user[ModelConstants.Credits] = parseFloat(user[ModelConstants.Credits]) - amount;
      var sendSuccess = locManager.localizedStringForKey("SEND_CREDIT_SUCCESS_ALERT_TITLE");
      var creditSent = locManager.localizedStringForKey("SEND_CREDIT_SUCCESS_ALERT_BODY");
      var okayText = locManager.localizedStringForKey("OK_ALERT_BUTTON");
      appManager.setCurrentUser(user, function()
      {
        appActions.showAlert(sendSuccess,creditSent,[okayText],[function(){appActions.requestPop(false);appActions.hideAlert();}]);
      });
    },
    function(data)
    {
      var sendFailedTitle = locManager.localizedStringForKey("SEND_CREDIT_FAIL_ALERT_TITLE");
      var sendFailedBody = locManager.localizedStringForKey("SEND_CREDIT_FAIL_ALERT_BODY");
      var okayText = locManager.localizedStringForKey("OK_ALERT_BUTTON");
      appActions.setSpinnerShown(false);
      appActions.showAlert(sendFailedTitle,sendFailedBody,[okayText]);
    }, function(data)
    {
      appActions.setSpinnerShown(false);
      appActions.showNetworkErrorAlert(appActions.hideAlert, function(){})
    })
  },

  didUpdate : function(data)
  {

  },

  _qrCodePulsing : false,
  setQRCodePulsing : function(enable)
  {
    if( enable != this._qrCodePulsing )
    {
      if( enable )
      {
        this.fadeInQRCode();
      }
      this._qrCodePulsing = enable;
    }
  },

  fadeInQRCode : function()
  {
    var thisThing = this;
    Animated.timing(
     thisThing.state.qrCodeOpacity,
     {toValue: 1,
     duration:700},
    ).start(function()
    {
      if( thisThing._qrCodePulsing ) thisThing.fadeOutQRCode();
    });
  },

  fadeOutQRCode : function()
  {
    var thisThing = this;
    Animated.timing(
     thisThing.state.qrCodeOpacity,
     {toValue: 0,
     duration:700},
    ).start(function()
    {
      if( thisThing._qrCodePulsing ) thisThing.fadeInQRCode();
    });
  },

  _userID : null,
  didScanData : function(data)
  {
    var jsonString = atob(data);
    var obj = JSON.parse(jsonString);
    if( obj )
    {
      if( obj.T == "GC" && typeof obj.U !== 'undefined' ) // is gift card
      {
        this._userID = obj.U;
        this.showPinScreen();
        return;
      }
    }
    this.showScanError();
  },

  showScanError : function()
  {
    var appActions = this.props.appActions;
    var thisThing = this;
    appActions.showLocalizedAlert("INVALIDQR_FAIL_ALERT_TITLE", "INVALIDQR_FAIL_ALERT_BODY", ["OK_ALERT_BUTTON"], [function()
    {
      appActions.hideAlert();
      thisThing.scanCard();
    }], function(){})
  },

  tryToScanCard : function()
  {
    var locManager = this.props.appManager.getLocalizationManager();

    if( Platform.OS === 'ios' )
    {
      var thisThing = this;
      var appActions = this.props.appActions;
      Camera.checkVideoAuthorizationStatus().then((hasPermission)=>
      {
        if( hasPermission )
        {
          thisThing.scanCard();
        }
        else
        {
          appActions.showAlert(locManager.localizedStringForKey("CAMERA_PERMISSION_TITLE"), locManager.localizedStringForKey("CAMERA_PERMISSION_BODY"),[locManager.localizedStringForKey("OK_ALERT_BUTTON")],[function(){appActions.hideAlert();}]);
        }
      })
    }
    else
    {
      this.scanCard();
    }
  },

  scanCard : function()
  {
    var cameraDim = Math.min(this.state.layout.width,this.state.layout.height) - 20;
    var thisThing = this;
    var appManager = thisThing.props.appManager;

    this.setQRCodePulsing(true);

    var customAlert = <ScrollView bounces={true} style={{margin:0,padding:0}}
          keyboardShouldPersistTaps={true}
          keyboardDismissMode={"interactive"}>
          <Camera ref={this.cameraDidLoad} style={{alignSelf:'center', height:cameraDim,width:cameraDim, justifyContent:'center', padding:10}}
            captureAudio={false}
            type={Camera.constants.Type.back}
            aspect={Camera.constants.Aspect.Fill}
            onBarCodeRead={(evt)=>
            {
              // {"data":"eyJVIjoiMTUwIiwiVCI6IkdDIiwiSCI6IjIyMGY2ZWNjZDIifQ==","type":"org.iso.QRCode","bounds":{"size":{"width":"0.377938","height":"0.672479"},"origin":{"x":"0.348706","y":"0.132129"}}}
              thisThing.didScanData(evt.data);
            }}>
              <Animated.View style={{opacity:thisThing.state.qrCodeOpacity}}><Icon name={"qrcode"} size={200} color={'black'} style={{backgroundColor:'transparent',justifyContent:'center', alignSelf:'center', padding:0, paddingBottom:0, lineHeight:216}}/></Animated.View>
          </Camera>
        </ScrollView>

        // <ScrollView bounces={true} style={{margin:0,padding:0}}
        //   keyboardShouldPersistTaps={true}
        //   keyboardDismissMode={"interactive"}>
        //   <Camera ref={this.cameraDidLoad} style={{alignSelf:'center', height:cameraDim,width:cameraDim, justifyContent:'center', padding:10}}
        //     captureAudio={false}
        //     captureTarget={Camera.constants.CaptureTarget.disk}
        //     type={Camera.constants.Type.back}
        //     aspect={Camera.constants.Aspect.Fill}>
        //       <Animated.View style={{opacity:thisThing.state.qrCodeOpacity}}><Icon name={"qrcode"} size={200} color={'black'} style={{backgroundColor:'transparent',justifyContent:'center', alignSelf:'center', padding:0, paddingBottom:0, lineHeight:216}}/></Animated.View>
        //   </Camera>
        // </ScrollView>
    this.props.appActions.setCustomAlertShown(true,customAlert, function()
    {
      thisThing.setQRCodePulsing(false);
    });
  },

  _number : "",
  numberChanged : function(text)
  {
    var didAddText = text.length > this.state.giftCardNumber.length;
    var noSpaces = removeSpaces(text);
    this._number = noSpaces;
    var moddedText = noSpaces.substring(0,5);
    if( noSpaces.length > 5 )
    {
      moddedText += " " + noSpaces.substring(5,10);
    }
    if( noSpaces.length > 10 )
    {
      moddedText += " " + noSpaces.substring(10,15);
    }
    var shouldShowButton = moddedText.length >= 1;
    if( shouldShowButton != this.state.shouldShowButton )
    {
      var thisThing = this;
      Animated.timing(
       thisThing.state.buttonOpacity,
       {toValue: shouldShowButton ? 1 : 0,
       duration:250},
      ).start(function()
      {

      });
    }
    this.setState({giftCardNumber:moddedText, shouldShowButton:shouldShowButton});
  },

  render: function()
  {
    var thisThing = this;
    var appManager = this.props.appManager;
    var appActions = this.props.appActions;
    var locManager = this.props.appManager.getLocalizationManager();
    var orLabel = locManager.localizedStringForKey("OR_LABEL");
    var user = this.state.user;

    var instructionColor = appManager.getColorForKey("InstructionColor");
    var instructionTitleColor = appManager.getColorForKey("InstructionTitleColor");
    var generalColor = appManager.getColorForKey("GeneralColor");
    var generalTitleColor = appManager.getColorForKey("GeneralTitleColor");
    var profileMeterColor = appManager.getColorForKey("ProfileMeterColor");
    var profileMeterBackgroundColor = appManager.getColorForKey("ProfileMeterBackgroundColor");
    var bodyColor = appManager.getColorForKey("FeedCardBodyColor");
    var primaryButtonColor = appManager.getColorForKey("ButtonPrimaryColor");
    var primaryButtonTitleColor = appManager.getColorForKey("ButtonPrimaryTitleColor");
    var primaryButtonBorderColor = appManager.getColorForKey("ButtonPrimaryBorderColor");
    var secondaryButtonColor = appManager.getColorForKey("ButtonSecondaryColor");
    var secondaryButtonTitleColor = appManager.getColorForKey("ButtonSecondaryTitleColor");
    var secondaryButtonBorderColor = appManager.getColorForKey("ButtonSecondaryBorderColor");

    var cardNumberLabel = "Gift Card Number";//TODO:localize
    var pinLabel = "PIN:";//TODO:localize
    var creditsPointLeftStatement = locManager.localizedStringForKey("CREDITS_POINTS_LEFT_STATEMENT");
    var absorbCardButton = "Enter PIN";//TODO:localize

    return (
      <View style={styles.container}>
        { this.props.extras && this.props.extras.shouldHideActionBar ? null : <View style={styles.actionBarSpacer} /> }
        <View style={[styles.backgroundView, {width:this.state.layout.width, height:this.state.layout.height, backgroundColor: generalColor}]} />
        <ReUpScrollView ref={(c) => { this._ref_ptr = c; }} bounces={true} responder={this}>
          <View style={[styles.instructionContainer, {backgroundColor: instructionColor}]}>
            <View style={{alignSelf:'center'}}>
              <ReUpText appManager={typeof appManager === 'undefined' ? null : appManager} numberOfLines={3} style={[styles.instructionText, {color:instructionTitleColor, width:this.state.layout.width - 80}]}>
                {creditsPointLeftStatement}
              </ReUpText>
            </View>
            <View style={{flex:1}} />
            <ReUpIconButton type={3}
              appManager={appManager}
              featureData={this.props.featureData}
              appActions={appActions}
              />
          </View>
          <ShadowView layout={this.state.layout} appManager={appManager}/>
          <View style={{paddingTop:20}}>
            <ReUpIconButton iconName={"camera"} type={0}
              appManager={appManager}
              onPress={() => {
                thisThing.tryToScanCard();
              }}
              />
            <ShadowView layout={this.state.layout} text={orLabel} appManager={appManager}/>
            <ReUpField
              appManager={appManager}
              key="number" ref={(c) => { this._ref_number = c; }}
              autoCapitalize={'none'}
              value={this.state.giftCardNumber}
              onChangeText={this.numberChanged}
              placeholder={cardNumberLabel}
              style={[styles.textField,{margin:10}]}
              maxLength={17}
              autoCapitalize={"characters"}/>
            <Animated.View style={{opacity:this.state.buttonOpacity}}>
              <ReUpButton appManager={appManager} style={[styles.doneButton, {marginTop:20}]} text={absorbCardButton}
                onPress={()=>{if( thisThing.state.shouldShowButton ) {thisThing._userID = null; this.showPinScreen()}}} />
            </Animated.View>
          </View>
        </ReUpScrollView>
      </View>
    );
  }
});

var styles = StyleSheet.create({
  container:{
    flex: 1,
    alignItems: 'stretch',
    flexDirection: 'column',
  },
  actionBarSpacer: {
    height:Globals.ACTION_BAR_HEIGHT,
  },
  instructionContainer: {
    flexDirection:'row',
  },
  instructionText: {
    margin:10,
  },
  backgroundView: {
    position: 'absolute',
  },


  // meter

  meterContainer: {
    margin:10,
    height:20,
    borderRadius:10,
    flexDirection:'row',
  },
  meterFiller: {
    margin:1,
    height:18,
    borderRadius:9,
  },
  meterAntiFiller: {
    height:18,
    borderRadius:9,
  },

  // body

  bodyText: {
    margin:10,
    textAlign:'left',

  },

  alertTitle: {
    margin:4,
    textAlign:'center',
  },

  // choices

  choicesContainer: {
    flexDirection:'row',
    marginTop:0,
    marginBottom:0,
    marginLeft:0,
    marginRight:0,
    height:50,
    alignItems:'center',
    justifyContent:'center'
  },
  choiceButton: {
    justifyContent:'center',
    flex:1,
    height:40,
  },

  // credit card
  oldCardContainer: {
    flexDirection:'row',
    margin:10,
    alignItems:'center',
    marginLeft:20,
    marginRight:20,
    justifyContent:'center',
  },
  creditCardIcon: {
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    padding:4,
    opacity:.6,
  },
  creditCardText: {
    fontStyle:'italic',
    padding:4,
    flex:1,
    textAlign:'center',
    opacity:.6,
  },
  creditCardEditButton: {
    padding:4,
  },
  creditCardEditButtonIcon: {
    backgroundColor:'transparent'
  },

  // new card
  cardNumberContainer: {
    flexDirection: 'row',
    margin:8,
    marginTop:0
  },

  textField: {
    flex:1,
    width:-1,
    height:50,
    marginTop:10
  },

  dateContainer: {
    flexDirection: 'row',
    alignItems:'flex-end',
    margin:8,
    marginTop:0,
  },
  dateField: {
    flex:-1,
    width:40,
    textAlign:'center',
  },
  cvvField: {
    flex:-1,
    width:80,
    textAlign:'center',
  },
  dateSlash: {
    paddingLeft:8,
    paddingRight:8,
    alignSelf:'flex-end',
    textAlign:'center',
  },

  doneButton: {
    justifyContent:'center',
    flex:1,
    marginRight:10, marginLeft:10, marginBottom:10,
  },

  segmentContainer: {
    height:50,
    padding:4,
    flex:1,
    alignSelf:'center'
  }
});

AbsorbGiftCard.getCards = function(featureData, appActions, data)
{
  var appManager = appActions._appManager;
  var isLoggedIn = appManager.isLoggedIn();

  if( !isLoggedIn || typeof ModelConstants === 'undefined' ) return [];
  else
  {
    var user = appManager.currentUser();
    var credit = user[ModelConstants.Credits]
    if( credit < 20) return [];

    var didSelect = function() {appActions.requestFeatureName("AbsorbGiftCard")};
    var iconName = featureData.data.icon.replace("fa-", "")
    return [{
      didSelect : didSelect,
      title : featureData.data.title,
      body1 : featureData.data.tip,
      icon : iconName,
      cardType : 0,
      sortOrder : 0
    }];
  }
}

AbsorbGiftCard.dataDependencies = ["Users"];

module.exports = AbsorbGiftCard;
